module.exports = __webpack_public_path__ + "img/cityPartner3.8e5ad7c5.png";